export default "__VITE_ASSET__DPMzMQV8__"